module.exports = __webpack_public_path__ + "media/images/folder-icon-97e5198bc0c9deb9aa900a219a27fa847875aaaefda6ccaa6c922dbc84e20456.svg";